<template>
  <base-popup
      :popup-model="show"
      title="Invoice Mail Template"
      :valid="!valid"
      :width="45"
      :show-save-button="false"
      @onCancelButtonClick="closeMailPopupHandler"
  >
    <v-card class="mt-5">
      <v-card-text id="myInput" class="mail-text-weight">
        <p>
          {{ getTemplateTitle(currentItem.billingType) }}<br><br>
          {{ mailTemplate.orderLinkText }}: <br><br>
          {{ mailTemplate.liveLinkText }}: {{getRefLink(currentItem.refcode)}}<br><br>
         <span class="mail-text-black">{{ mailTemplate.stepTitle }}</span><br>
        </p>
        <span v-for="item in mailTemplate.steps" :key="item">{{item}}<br></span>
        <br>
        <p class="mail-text-black">{{ mailTemplate.note }}</p>
      </v-card-text>
    </v-card>
  </base-popup>
</template>

<script>
import BasePopup from "./BasePopup";
import Popup from "../mixins/Popup";
import mailTemplate from "../../json/mailTemplate.json"

export default {
  name: "MailTemplatePopup",
  mixins: [Popup],
  components: {BasePopup},
  data() {
    return {
      selectedItem: 0,
      mailTemplate: mailTemplate
    }
  },
  computed: {
    getLinks() {
      return this.currentItem.link ? this.currentItem.link.split('@') : [];
    }
  },
  methods: {
    closeMailPopupHandler() {
      this.$emit('closeMailPopupHandler');
    },
    liveLinkHandler(site) {
      window.open(site, '_blank');
    },
    getRefLink(refcode) {
      const api = process.env.VUE_APP_BASE_URL;
      return `${api}/payment?refno=${refcode}`;
    },
    getTemplateTitle(title) {
      return this.mailTemplate.title.replaceAll('type', title);
    }
  }
}
</script>

<style scoped lang="scss">
.mail-text-weight{
  font-weight: 500 !important;
}
.mail-text-black{
  color: #000 !important;
}
</style>